import { createSelector } from 'reselect'

export const getDocumentTemplateSources = (state, props) => {
  return state.kanbo.documentTemplateSources.ids
}

export const getDocumentTemplateSourcesById = (state, props) => {
  return state.kanbo.documentTemplateSources.byId
}

export const makeDocumentTemplateSourcesSelector = () => createSelector(
  [getDocumentTemplateSources, getDocumentTemplateSourcesById],
  (documentSources, documentSourcesById) => {
    return documentSources.map(id => documentSourcesById[id])
  }
)

export const documentTemplateSourcesSelector = makeDocumentTemplateSourcesSelector()
